/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ValidateNewAutomationMutationRequest,
  ValidateNewAutomationMutationResponse,
  ValidateNewAutomationPathParams,
  ValidateNewAutomation400,
} from '../types/ValidateNewAutomation'

function getValidateNewAutomationUrl({
  company_id,
}: {
  company_id: ValidateNewAutomationPathParams['company_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/automations/validation/company/${company_id}/validate-new/` as const,
  }
  return res
}

/**
 * @description Validate that a new automation won't create cycles.
 * POST /automations/validation/company/{company_id}/validate-new/
 * Body: {
 * "trigger_type": "field_changed_account_owner",
 * "action_type": "change_sales_stage"
 * }
 * @summary Validate that a new automation won't create cycles
 * {@link /api/v1/automations/validation/company/:company_id/validate-new/}
 */
export async function validateNewAutomation(
  { company_id }: { company_id: ValidateNewAutomationPathParams['company_id'] },
  data: ValidateNewAutomationMutationRequest,
  config: Partial<RequestConfig<ValidateNewAutomationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ValidateNewAutomationMutationResponse,
    ResponseErrorConfig<ValidateNewAutomation400>,
    ValidateNewAutomationMutationRequest
  >({
    method: 'POST',
    url: getValidateNewAutomationUrl({ company_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
